// extracted by mini-css-extract-plugin
export var drawerPaper = "_1d-0";
export var itemImage = "_1d-1";